import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import BusinessPlanPage from "@/pages/BusinessPlanPage";
import FinancialsPage from "@/pages/FinancialsPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import BookingPage from "@/pages/BookingPage";
import DashboardLayout from "@/layouts/DashboardLayout";
import GrantTrackerPage from "@/pages/dashboard/GrantTrackerPage";
import AIWriterPage from "@/pages/dashboard/AIWriterPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<ServicesPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/business-plan" element={<BusinessPlanPage />} />
          <Route path="/financials" element={<FinancialsPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/book" element={<BookingPage />} />
          
          {/* Dashboard Routes */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<GrantTrackerPage />} />
            <Route path="grants" element={<GrantTrackerPage />} />
            <Route path="ai-writer" element={<AIWriterPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
